module.exports = __webpack_public_path__ + "static/media/BonusOfferingsPanel.b531c24e.png";